// Shared pure metadata guards for Apple search cards and local projections.
// Missing or malformed values stay unknown; they are never coerced to 1970.
export function releaseYear(item = {}) {
  if (!item || typeof item !== 'object' || Array.isArray(item)) return '';
  for (const value of [item.year, item.publishTime, item.publishDate, item.releaseDate]) {
    const year = validYear(value);
    if (year) return year;
  }
  return '';
}

export function validYear(value) {
  if (typeof value !== 'string' && typeof value !== 'number') return '';
  const text = String(value).trim();
  if (!text || text === '0' || text === 'false') return '';
  if (/^\d{4}$/.test(text)) return Number(text) >= 1000 ? text : '';
  if (/^\d{4}-\d{2}-\d{2}(?:$|T)/.test(text)) {
    const date = new Date(text);
    const year = date.getUTCFullYear();
    return Number.isFinite(date.getTime()) && year >= 1000 && year <= 9999 ? String(year) : '';
  }
  if (!/^\d{1,13}$/.test(text)) return '';
  const number = Number(text);
  // Ignore tiny numeric values that would otherwise become a misleading
  // 1970-era date. Four-digit calendar years were handled above.
  if (!Number.isFinite(number) || number < 1e9) return '';
  const date = new Date(number < 1e11 ? number * 1000 : number);
  const year = date.getUTCFullYear();
  return Number.isFinite(date.getTime()) && year >= 1000 && year <= 9999 ? String(year) : '';
}

// A full release date needs a real day, not just the year used by search cards.
export function releaseDate(item = {}) {
  if (!item || typeof item !== 'object' || Array.isArray(item)) return '';
  for (const value of [item.publishTime, item.publishDate, item.releaseDate, item.date]) {
    if (!validYear(value)) continue;
    const text = String(value).trim();
    if (/^\d{4}$/.test(text)) continue;
    const calendar = text.match(/^\d{4}-\d{2}-\d{2}/)?.[0];
    if (calendar) {
      const day = new Date(calendar + 'T00:00:00Z');
      if (!Number.isFinite(day.getTime()) || day.toISOString().slice(0, 10) !== calendar) continue;
    }
    const timestamp = /^\d{10,13}$/.test(text) ? Number(text) : null;
    const date = new Date(timestamp === null ? text : timestamp < 1e11 ? timestamp * 1000 : timestamp);
    if (Number.isFinite(date.getTime())) return date.toISOString().slice(0, 10);
  }
  return '';
}

export function localAlbumReleaseYear(tracks = []) {
  for (const track of Array.isArray(tracks) ? tracks : []) {
    const metadata = track?.metadata || {};
    const year = releaseYear(metadata);
    if (year) return year;
  }
  return '';
}

export function firstPresent(...values) {
  return values.find(value => value !== null && value !== undefined);
}
